<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<repay-mst-search ref="repayMstSearch" @Refresh="Refresh" :scrId="scrId" />
				</sf-card>
			</div>
			<div class="sf-col sf-col-20 position-relative">
				<!--총 합계리스트 -->
				<sf-card class="p-0 border-0 bg-transparent position-absolute" style="top: 10px">
					<repay-mst-table2 ref="table2" :scrId="scrId"></repay-mst-table2>
				</sf-card>
				<!--변제처리 리스트 -->
				<sf-card class="p-0 border-0 bg-transparent w-100 position-absolute" style="top: 85px">
					<repay-mst-table ref="table" :scrId="scrId" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 끝-->
		</div>
	</div>
</template>

<script>
import RepayMstSearch from './Search/RepayMstSearch.vue';
import RepayMstTable from './Table/RepayMstTable.vue';
import RepayMstTable2 from './Table/RepayMstTable2.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { RepayMstSearch, RepayMstTable, RepayMstTable2 },
	methods: {
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.repayMstSearch.searchList();
		}
	}
};
</script>

<style></style>
